module.exports = __webpack_public_path__ + "media/images/thumbs/anatomyphysiology/am765-dae38f859bec85e400810e02b2ba70c1.jpg";